module.exports = __webpack_public_path__ + "img/invoice.08911425.png";